export enum InteractionImage {
  // dragAndDrop
  DragAndDropPositiveResult = '/assets/interactions/dragAndDrop/positiveResult.svg',
  DragAndDropNegativeResult = '/assets/interactions/dragAndDrop/negativeResult.svg'
}
